<template>
  <billing-overdue-notification-container />
  <status-page-incident-notification-container />
</template>

<script>
import BillingOverdueNotificationContainer from '@/apps/admin/billing/components/container/BillingOverdueNotificationContainer.vue';
import StatusPageIncidentNotificationContainer from '@/commons/components/container/StatusPageIncidentNotificationContainer.vue';

export default {
  name: 'top-notifications',
  components: {
    BillingOverdueNotificationContainer,
    StatusPageIncidentNotificationContainer
  }
};
</script>
